import { PageHeader } from "@/components/page";
import { CreateTeamDialog } from "@/components/teams/CreateTeamDialog";
import { TeamsTable } from "@/components/teams/TeamsTable";
import { useGetTenantByFriendly } from "@/hooks/queryHooks/tenantHooks";
import { useRoleProtected } from "@/hooks/useRoleProtected";
import { DataTableWrapper } from "@repo/ui/components/Base/DataTable";
import { useParams } from "react-router-dom";

export const TeamsPage = () => {
  const { tenantId } = useParams();
  useRoleProtected("admin");
  const { loaded: tenantLoaded, data: tenantData } = useGetTenantByFriendly(
    tenantId ?? ""
  );

  return (
    <div className="flex flex-col flex-grow">
      <PageHeader
        title={tenantData?.name ? `${tenantData.name}'s Teams` : "Teams"}
      >
        {" "}
        {tenantData?.id && <CreateTeamDialog tenantId={tenantData.id} />}
      </PageHeader>

      {!tenantLoaded && <div>Loading ... </div>}

      {tenantLoaded && tenantData?.id && (
        <DataTableWrapper>
          <TeamsTable tenantId={tenantData.id} />
        </DataTableWrapper>
      )}
    </div>
  );
};
